module.exports = __webpack_public_path__ + "static/Invoice-System-5-8aad8052105c53a917adc3a4107eac58.svg";